<template>
  <vx-card title="Payment Mode">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getPaymentModeLookup"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>IsUsed</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].paymentModeId">
                      {{ data[indextr].paymentModeId }}
                    </vs-td>
                    <vs-td :data="data[indextr].paymentModeCode">
                      {{ data[indextr].paymentModeCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].paymentModeName">
                      {{ data[indextr].paymentModeName }}
                    </vs-td>

                    <vs-td :data="data[indextr].isUsed">
                      <vs-checkbox
                        v-model="data[indextr].isUsed"
                        class="pointer-events-none"
                      />
                    </vs-td>

                    <vs-td>
                      <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                        <feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].paymentModeId)"
                        />
                        <!-- <feather-icon
                          icon="Trash2Icon"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="
                            confirmDeleteRecord(data[indextr].paymentModeId)
                          "
                        /> -->
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
      <!-- EDIT EARNINGS -->
      <vs-prompt
        class="email-compose"
        title="Edit Payment Mode"
        accept-text="Submit"
        @accept="onUpdateRecord"
        :is-valid="validForm"
        :active.sync="activePromptEditRecord"
      >
        <vx-card title="You may update the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="paymentMode.paymentModeCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="paymentMode.paymentModeName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/32 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="paymentMode.isUsed">isUsed</vs-checkbox>
              </div>
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END EDIT EARNINGS -->
    </div>
  </vx-card>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

export default {
  data() {
    return {
      paymentMode: {
        paymentModeId: 0,
        paymentModeCode: "",
        paymentModeName: "",
        divisor: 2,
        isUsed: true,
      },
      activePromptEditRecord: false,
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllPaymentModeLookup").catch((err) => {
      console.log(err);
    });
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    getPaymentModeLookup() {
      return this.$store.state.lookup.getAllPaymentModeLookup;
    },
    validForm() {},
  },
  methods: {
    editRecord(id) {
      const e = this.$store.getters["lookup/paymentModeLookup"](id);

      (this.paymentMode.paymentModeId = id),
        (this.paymentMode.paymentModeCode = e.paymentModeCode),
        (this.paymentMode.paymentModeName = e.paymentModeName),
        (this.paymentMode.divisor = e.divisor),
        (this.paymentMode.isUsed = e.isUsed);

      this.activePromptEditRecord = true;
    },
    onUpdateRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/updatePayment", this.paymentMode)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Updated Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
  },
};
</script>
